import React from "react";

export function onEnterKey(e: React.KeyboardEvent<HTMLInputElement|HTMLTextAreaElement>, callback: () => void) {
    if (["Enter", "NumpadEnter"].includes(e.key)) callback();
}